import { render, staticRenderFns } from "./ConsultaVirtual.vue?vue&type=template&id=45c9edb2&scoped=true"
import script from "./ConsultaVirtual.vue?vue&type=script&lang=js"
export * from "./ConsultaVirtual.vue?vue&type=script&lang=js"
import style0 from "./ConsultaVirtual.vue?vue&type=style&index=0&id=45c9edb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c9edb2",
  null
  
)

export default component.exports